/* Shared behavior for the modular shower-filter PDP. */
(()=>{
  if(window.__filtaryPdpRuntimeBound)return;
  window.__filtaryPdpRuntimeBound=true;
  const root=()=>document.getElementById('flt-lp');
  const form=()=>document.getElementById('flt-form');
  const submitButtons=f=>Array.from(new Set([
    ...f.querySelectorAll('button[type="submit"]'),
    ...document.querySelectorAll('button[form="flt-form"][type="submit"]')
  ]));

  // FIX-STICKY 2026-09-24: the bar is rendered visible (class "show") so a price and an order button are on
  // the first screen. It hides only while another order button of this form (the buy box's own button or the
  // final one) is on screen above the bar's top edge, so two order buttons are never visible together.
  function updateSticky(){
    const lp=root();if(!lp)return;
    const sticky=lp.querySelector('#flt-sticky');
    const heroButton=lp.querySelector('#flt-form .hero button[type="submit"]');
    if(!sticky||!heroButton)return;
    const edge=innerHeight-sticky.offsetHeight;
    const onScreen=button=>{const r=button.getBoundingClientRect();return r.height>0&&r.bottom>0&&r.top<edge;};
    const others=[heroButton,...document.querySelectorAll('button[form="flt-form"][type="submit"]')];
    sticky.classList.toggle('show',!others.some(onScreen));
  }

  function syncBundle(label){
    const lp=root();if(!lp||!label)return;
    lp.querySelectorAll('.bundle').forEach(x=>x.classList.remove('active'));
    label.classList.add('active');
    const price=label.getAttribute('data-price');
    const old=label.getAttribute('data-old');
    const save=label.getAttribute('data-save');
    const priceRow=lp.querySelector('#flt-price');
    if(priceRow){
      let html='<div class="price-now">'+price+' <span class="cur">IQD</span></div>';
      if(old)html+='<div class="price-old">'+old+'</div>';
      if(save&&save!=='0')html+='<div class="save-tag">وفّر '+save+'٪</div>';
      priceRow.innerHTML=html;
    }
    const stickyPrice=lp.querySelector('#flt-sticky-price');
    const stickyOld=lp.querySelector('#flt-sticky-old');
    if(stickyPrice)stickyPrice.textContent=price+' IQD';
    if(stickyOld)stickyOld.textContent=old||'';
    const finalPriceRow=lp.querySelector('#flt-final-price');
    if(finalPriceRow){
      let html='<div class="price-now">'+price+' <span class="cur">IQD</span></div>';
      if(old)html+='<div class="price-old" style="color:#ffd0d2">'+old+'</div>';
      finalPriceRow.innerHTML=html;
    }
  }

  async function readCart(shopRoot){
    const response=await fetch(shopRoot+'cart.js',{headers:{'Accept':'application/json'}});
    if(!response.ok)throw new Error('cart-read-failed');
    return response.json();
  }

  function cartTierState(cart,selectedId,tierIds){
    const selected=String(selectedId);
    const tiers=new Set(tierIds.map(String));
    const items=Array.isArray(cart?.items)?cart.items:[];
    return {
      selectedPresent:items.some(item=>String(item.variant_id??item.id)===selected&&Number(item.quantity)>0),
      otherTierPresent:items.some(item=>{
        const id=String(item.variant_id??item.id);
        return id!==selected&&tiers.has(id)&&Number(item.quantity)>0;
      })
    };
  }

  const installationState=new WeakMap();
  function installationRoots(scope){
    const roots=[];
    if(scope?.matches?.('#pdp-installation'))roots.push(scope);
    scope?.querySelectorAll?.('#pdp-installation').forEach(node=>roots.push(node));
    return roots;
  }

  function teardownInstallation(root){
    const state=installationState.get(root);if(!state)return;
    state.observer.disconnect();
    state.near?.disconnect();
    state.motion.removeEventListener?.('change',state.onMotionChange);
    state.videos.forEach(video=>video.pause());
    installationState.delete(root);
  }

  function initInstallation(scope=document){
    installationRoots(scope).forEach(root=>{
      if(installationState.has(root))return;
      const motion=matchMedia('(prefers-reduced-motion: reduce)');
      const videos=Array.from(root.querySelectorAll('video'));
      const visibility=new WeakMap();
      // FIX-MEDIA 2026-09-23: source and poster are attached only within about one screen of the viewport.
      function mount(video){
        if(!video.dataset.src||video.getAttribute('src'))return;
        if(video.dataset.poster)video.setAttribute('poster',video.dataset.poster);
        video.preload=motion.matches?'metadata':'auto';
        video.src=video.dataset.src;
      }
      function update(video,visible){
        visibility.set(video,visible);
        video.muted=true;
        if(visible)mount(video);
        if(motion.matches){video.pause();video.controls=true;video.autoplay=false;}
        else{video.controls=false;if(visible)video.play().catch(error=>{if(!error||error.name!=='AbortError')video.controls=true;});else video.pause();}
      }
      const observer=new IntersectionObserver(entries=>entries.forEach(entry=>update(entry.target,entry.isIntersecting)),{threshold:.15});
      const near=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting)mount(entry.target);}),{rootMargin:'100% 0px'});
      videos.forEach(video=>{
        const rect=video.getBoundingClientRect();
        update(video,rect.bottom>0&&rect.top<innerHeight);
        observer.observe(video);
        near.observe(video);
      });
      const onMotionChange=()=>videos.forEach(video=>update(video,visibility.get(video)??(video.getBoundingClientRect().bottom>0&&video.getBoundingClientRect().top<innerHeight)));
      motion.addEventListener?.('change',onMotionChange);
      installationState.set(root,{observer,near,motion,onMotionChange,videos});
    });
  }

  function renderCart(sections){
    if(!sections)return;
    const drawerHtml=sections['cart-drawer'];
    if(drawerHtml){
      const parsed=new DOMParser().parseFromString(drawerHtml,'text/html');
      const fresh=parsed.querySelector('cart-drawer');
      const live=document.querySelector('cart-drawer');
      if(fresh&&live)live.replaceWith(document.importNode(fresh,true));
    }
    const bubbleHtml=sections['cart-icon-bubble'];
    if(bubbleHtml){
      const liveBubble=document.getElementById('cart-icon-bubble');
      if(liveBubble){
        const parsed=new DOMParser().parseFromString(bubbleHtml,'text/html');
        liveBubble.innerHTML=(parsed.querySelector('.shopify-section')||parsed.body).innerHTML;
      }
    }
  }

  function openCart(){
    const drawer=document.querySelector('cart-drawer');
    if(drawer&&typeof drawer.open==='function'){try{drawer.open();return;}catch(error){}}
    const icon=document.querySelector('a[href="/cart"],a[href^="/cart"],.header__icon--cart,#cart-icon-bubble');
    if(icon){icon.click();return;}
    if(drawer){
      drawer.classList.remove('is-empty');
      drawer.classList.add('animate','active');
      document.body.classList.add('overflow-hidden');
    }
  }

  document.addEventListener('change',event=>{
    const radio=event.target.closest?.('#flt-form .bundle .v-radio');
    if(radio&&radio.checked)syncBundle(radio.closest('.bundle'));
  });

  // FIX-DRAWER-ATC 2026-09-24: capture phase, so preventDefault runs before Shopify's own form-level submit
  // listener (bound at window load). That listener skips cancelled submits, so each tap reports one add-to-cart
  // (from the cart/add.js call) instead of two.
  document.addEventListener('submit',async event=>{
    const activeForm=form();
    if(!activeForm||event.target!==activeForm)return;
    event.preventDefault();
    if(activeForm.dataset.fltSubmitting==='1')return;
    const checked=activeForm.querySelector('input[name="id"]:checked');
    if(!checked){HTMLFormElement.prototype.submit.call(activeForm);return;}
    activeForm.dataset.fltSubmitting='1';
    const buttons=submitButtons(activeForm);
    const submitter=event.submitter||buttons[0];
    const originalText=submitter?submitter.innerHTML:'';
    buttons.forEach(button=>{button.disabled=true;button.style.opacity='.7';});
    const shopRoot=window.Shopify?.routes?.root||'/';
    const tierIds=Array.from(activeForm.querySelectorAll('.v-radio')).map(input=>input.value);
    const updates={};
    tierIds.forEach(id=>{if(String(id)!==String(checked.value))updates[id]=0;});
    const body={
      items:[{id:checked.value,quantity:1}],
      sections:['cart-drawer','cart-icon-bubble'],
      sections_url:window.location.pathname
    };
    try{
      let updateSafe=true;
      try{
        const updateResponse=await fetch(shopRoot+'cart/update.js',{
          method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({updates})
        });
        updateSafe=updateResponse.ok;
      }catch(error){updateSafe=false;}

      if(!updateSafe){
        const state=cartTierState(await readCart(shopRoot),checked.value,tierIds);
        if(state.otherTierPresent){window.location.href=shopRoot+'cart';return;}
      }

      let addResponse;
      let addData;
      try{
        addResponse=await fetch(shopRoot+'cart/add.js',{
          method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify(body)
        });
        addData=await addResponse.json();
        if(!addResponse.ok||(addData&&addData.status))throw new Error('cart-add-failed');
      }catch(error){
        try{
          const state=cartTierState(await readCart(shopRoot),checked.value,tierIds);
          if(state.selectedPresent||state.otherTierPresent){window.location.href=shopRoot+'cart';return;}
          HTMLFormElement.prototype.submit.call(activeForm);
        }catch(readError){window.location.href=shopRoot+'cart';}
        return;
      }

      try{
        renderCart(addData.sections);
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
        document.dispatchEvent(new CustomEvent('cart:build',{bubbles:true}));
      }catch(error){window.location.href=shopRoot+'cart';return;}
      buttons.forEach(button=>{button.style.opacity='';});
      if(submitter){
        submitter.innerHTML='تمت الإضافة ✓';
        submitter.style.setProperty('background-color','#10b981','important');
        submitter.style.color='#fff';
      }
      setTimeout(openCart,150);
      setTimeout(()=>{
          buttons.forEach(button=>{button.disabled=false;});
          if(submitter){
            submitter.innerHTML=originalText;
            submitter.style.removeProperty('background-color');
            submitter.style.color='';
          }
        delete activeForm.dataset.fltSubmitting;
      },2500);
    }catch(error){window.location.href=shopRoot+'cart';}
  },true);

  function init(){
    const activeForm=form();
    const checked=activeForm?.querySelector('.bundle .v-radio:checked');
    if(checked)syncBundle(checked.closest('.bundle'));
    initInstallation(document);
    updateSticky();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
  window.addEventListener('scroll',updateSticky,{passive:true});
  window.addEventListener('resize',updateSticky,{passive:true});
  document.addEventListener('shopify:section:load',()=>requestAnimationFrame(init));
  document.addEventListener('shopify:section:unload',event=>installationRoots(event.target).forEach(teardownInstallation));
})();
